/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from 'react';
import queryString from 'query-string';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import top from './image/top_800x6.png';
import central from './image/linea_central_800x24.jpg';
import base from './image/base_naranja_800x34.jpg';
import kolbi from './image/kolbi-paramount-plus.jpg'
import LoginForm from './LoginForm';

const Login = ({ translate, location }) => {
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);

  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  useEffect(() => {
    document.body.className = 'ice-body';
    document.title = 'Instituto Costarricense de Electricidad - AV';
  }, []);


  return (
    <div className="ice-container">
      <div className="khtvHeader">
        <img src={top} alt="header" />
        <img src={kolbi} alt="header" />
        <img src={central} alt="header" />
      </div>
      {
        _validateParams()
          ? <LoginForm
            api={api}
            location={location}
          />
          : <RequestLoginErrorMessage
            onlyMessage={true}
            message={translate('RequestLoginErrorMessage')}
          />
      }
      <div className="khtvHeader">
        <img src={base} alt="header" />
      </div>
    </div>
  );
}

export default Login;
